class HeaderScroll {
  constructor() {
    this.header = document.querySelector('.header-wrapper');
    this.lastScrollTop = 0;
    this.scrollThreshold = 300; // 滚动阈值，可以根据需要调整
    this.isScrolling = false;
    this.scrollTimeout = null;
    this.headerHeight = this.header.offsetHeight;

    this.init();
  }

  init() {
    // 添加过渡效果
    this.header.style.transition = 'transform 0.3s ease-in-out';
    
    // 监听滚动事件
    window.addEventListener('scroll', () => {
      if (!this.isScrolling) {
        this.isScrolling = true;
        requestAnimationFrame(() => this.handleScroll());
      }
    });

    // 监听窗口大小变化，更新header高度
    window.addEventListener('resize', () => {
      this.headerHeight = this.header.offsetHeight;
    });
  }

  handleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDelta = currentScrollTop - this.lastScrollTop;
    
    // 如果滚动距离小于阈值，显示导航栏
    if (currentScrollTop < this.scrollThreshold) {
      this.showHeader();
    } else {
      // 判断滚动方向
      if (scrollDelta > 0) {
        // 向下滚动
        this.hideHeader();
      } else if (scrollDelta < 0) {
        // 向上滚动
        this.showHeader();
      }
    }

    this.lastScrollTop = currentScrollTop;
    this.isScrolling = false;
  }

  hideHeader() {
    this.header.style.transform = `translateY(-${this.headerHeight}px)`;
  }

  showHeader() {
    this.header.style.transform = 'translateY(0)';
  }
}

// 当 DOM 加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  new HeaderScroll();
}); 